export const isEditInvoiceURL = new RegExp(/^\/invoices\/edit\/([a-z]|-|[0-9])*/);

export const isEditTaxURL = new RegExp(/^\/taxes\/edit\/([a-z]|-|[0-9])*/);

export const isEditItemURL = new RegExp(/^\/items\/edit\/([a-z]|-|[0-9])*/);

export const isDuplicateItemURL = new RegExp(/^\/items\/duplicate\/([a-z]|-|[0-9])*/);

export const isEditCategoryURL = new RegExp(/^\/categories\/edit\/([a-z]|-|[0-9])*/);

export const isEditServiceChargeURL = new RegExp(/^\/service-charges\/edit\/([a-z]|-|[0-9])*/);

export const isRespondToDisputeUrl = new RegExp(/^\/payments\/disputes\/([a-z]|-|[0-9])*\/respond\/([a-z]|-|[0-9])*/);
export const isUploadEvidenceUrl = new RegExp(
  /^\/payments\/disputes\/([a-z]|-|[0-9])*\/update-evidence\/([a-z]|-|[0-9])*/
);
export const isReviewSubmitDisputeUrl = new RegExp(
  /^\/payments\/disputes\/([a-z]|-|[0-9])*\/review-and-submit\/([a-z]|-|[0-9])*/
);
export const isViewDisputeEvidenceUrl = new RegExp(
  /^\/payments\/disputes\/([a-z]|-|[0-9])*\/view-evidence\/([a-z]|-|[0-9])*/
);

export const isEditJobURL = new RegExp(/^\/jobs\/edit\/([a-z]|-|[0-9])*/);

// Add this new pattern for editing estimates
export const isEditEstimateURL = new RegExp(/^\/estimates\/edit\/([a-z]|-|[0-9])*/);
export const isDuplicateEstimateURL = new RegExp(/^\/estimates\/duplicate\/([a-z]|-|[0-9])*/);

export const isEditCommissionRuleURL = new RegExp(/^\/settings\/commission-settings\/edit-rule\/([a-z]|-|[0-9])*/);
export const isEditTagURL = new RegExp(/^\/settings\/tags\/edit\/([a-z]|-|[0-9])*/);
export const isEditExternalCompanyURL = new RegExp(/^\/settings\/external-company\/edit-company\/([a-z]|-|[0-9])*/);
export const isDuplicateJobURL = new RegExp(/^\/jobs\/duplicate\/([a-z]|-|[0-9])*/);

export const isPayPeriodReviewURL = new RegExp(/^\/accounting\/pay-runs\/pay-period-review\/([a-z]|-|[0-9])*/);
export const isMemberReviewPage = new RegExp(/^\/accounting\/pay-runs\/([a-z]|-|[0-9])*\/members\/([a-z]|-|[0-9])*/);
export const isEditServiceAreaURL = new RegExp(/^\/settings\/service-areas\/edit\/([a-z]|-|[0-9])*/);
